module.exports = __webpack_public_path__ + "static/media/zzc-default-img.9282e76d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zzc-default-img.svg
// module id = 424
// module chunks = 49